export default __webpack_public_path__ + "static/media/aeroland-sass-image-01.ec31e529.png";